import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">漫画分类</h2>
        <Link
          to="/category/all"
          className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
        >
          查看全部
          <i className="ri-arrow-right-line text-xs"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-2 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
          >
            <div className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all">
              <i className={`${cat.icon} text-lg`}></i>
            </div>
            <span className="text-xs font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">{cat.name}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}